/*
 * Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
 * Venelin Iliev <http://veneliniliev.com>
 */

import { Injectable } from '@angular/core';
import { ResourceInterface } from '@app/shared/models/resource.interface';
import { HttpClient } from '@angular/common/http';
import { ApiQuery } from '@app/core/http/api-query';
import { Observable } from 'rxjs';
import { PaginatedResponse } from '@app/shared/models/paginated-response.model';
import { map } from 'rxjs/operators';
import { HttpResponse } from '@app/core';
import { Client } from '@app/clients/clients/client.model';
import { Model } from '@app/shared/models/model.model';

@Injectable({
  providedIn: 'root',
})
export class ClientsService implements ResourceInterface {
  constructor(private http: HttpClient) {}

  index(query: ApiQuery = new ApiQuery()): Observable<PaginatedResponse> {
    return this.http.get('v1/clients', query.buildGetOptions()).pipe(
      map((response: HttpResponse) => {
        response.data = response.data.map((client: any) => {
          return new Client().deserialize(client);
        });

        return new PaginatedResponse().deserialize(response);
      })
    );
  }

  search(keywords: string = null, query: ApiQuery = new ApiQuery()): Observable<PaginatedResponse> {
    const options = query.buildGetOptions();
    if (keywords) {
      options.params = options.params.set('keywords', keywords);
    }
    return this.http.get('v1/clients/search', options).pipe(
      map((response: HttpResponse) => {
        response.data = response.data.map((client: any) => {
          return new Client().deserialize(client);
        });

        return new PaginatedResponse().deserialize(response);
      })
    );
  }

  update(client: Client): Observable<Client> {
    return this.http.put('v1/clients/' + client.id, client).pipe(
      map((response: HttpResponse) => {
        return new Client().deserialize(response.data);
      })
    );
  }

  store(client: Client): Observable<Client> {
    return this.http.post('v1/clients', client).pipe(
      map((response: HttpResponse) => {
        return new Client().deserialize(response.data);
      })
    );
  }

  show(id: number, query: ApiQuery = new ApiQuery()): Observable<Model> {
    return this.http.get('v1/clients/' + id, query.buildGetOptions()).pipe(
      map((response: HttpResponse) => {
        return new Client().deserialize(response.data);
      })
    );
  }

  destroy(id: number): Observable<any> {
    return this.http.delete('v1/clients/' + id);
  }
}
